import { useMemo } from 'react';
import { getAddress } from 'ethers';

const useContractAddress = (network) => {
  const contractAddress = useMemo(() => {
    if (!network) return null;

    let address;
    switch (Number(network.chainId)) {
      case 1: // Mainnet
        address = process.env.REACT_APP_CONTRACT_ADDRESS_MAINNET;
        break;
      case 56: // BSC
        address = process.env.REACT_APP_CONTRACT_ADDRESS_BSC;
        break;
      case 97: // BNB Testnet
        address = process.env.REACT_APP_CONTRACT_ADDRESS_BNB_TESTNET;
        break;
      case 137: // Polygon
        address = process.env.REACT_APP_CONTRACT_ADDRESS_POLYGON;
        break;
      case 11155111: // Sepolia
        address = process.env.REACT_APP_CONTRACT_ADDRESS_SEPOLIA;
        break;
      default:
        return null;
    }
    
    if (!address) return null;
    
    try {
      return getAddress(address.toLowerCase());
    } catch (error) {
      console.error("Invalid contract address:", address, error);
      return null;
    }
  }, [network]);

  return contractAddress;
};

export default useContractAddress;